(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        const searchLocationForm = document.querySelector(".services-groups-search-header .search-location-form");

        const cardFilterModules = document.querySelectorAll(".card-filters");
        Array.prototype.forEach.call(cardFilterModules, (currentCardFilterModule) => {
            const cardFilterInputs = currentCardFilterModule.querySelectorAll(".card-filter-inputs button");
            const loadMoreBtn = currentCardFilterModule.querySelector(".loadMoreBtn");

            Array.prototype.forEach.call(cardFilterInputs, (currentCardFilterInput) => {
                currentCardFilterInput.addEventListener("click", () => {
                    filtering.filterItems(currentCardFilterModule, cardFilterInputs, currentCardFilterInput, loadMoreBtn);
                });
            });

            loadMoreBtn.addEventListener("click", () => {
                filtering.loadMore(currentCardFilterModule, loadMoreBtn);
            });
        });

        const mapContainer = document.querySelector(".search-location-map");
        if (mapContainer) {
            let lat = searchLocationForm.getAttribute("data-selected-lat");
            let lng = searchLocationForm.getAttribute("data-selected-lng");
            let zoom = parseInt(searchLocationForm.getAttribute("data-zoom"));

            let selectedLat = lat !== "" ? parseFloat(lat) : 54.4263196;
            let selectedLng = lng !== "" ? parseFloat(lng) : -4.36647;
            let locations = [];

            document.querySelectorAll(".filter-item:not(.is-filtered)").forEach((item, index) => {
                locations.push({
                    title: item.getAttribute("data-map-title"),
                    url: item.getAttribute("data-map-url"),
                    description: item.getAttribute("data-map-description"),
                    lat: parseFloat(item.getAttribute("data-map-lat")),
                    lng: parseFloat(item.getAttribute("data-map-lng"))
                });
            });

            map.initMap(mapContainer, selectedLat, selectedLng, zoom, locations);
        }

        const mapBtn = document.querySelector(".toggle-map");
        if (mapBtn) {
            mapBtn.addEventListener("click", () => {
                const cardContainer = document.getElementById("results-list");
                const mapContainer = document.getElementById("results-map");
                const btnIcon = mapBtn.querySelector("i");
                const btnText = mapBtn.querySelector("span");
                let isHidden = mapContainer.classList.contains("is-d-none");

                if (isHidden) {
                    cardContainer.classList.add("is-d-none");
                    mapContainer.classList.remove("is-d-none");
                    btnText.textContent = "List View";
                    btnIcon.classList.remove("rethink-icon-crosshair");
                    btnIcon.classList.add("rethink-icon-list-view");

                } else {
                    cardContainer.classList.remove("is-d-none");
                    mapContainer.classList.add("is-d-none");
                    btnText.textContent = "Map View";
                    btnIcon.classList.remove("rethink-icon-list-view");
                    btnIcon.classList.add("rethink-icon-crosshair");
                }
            });
        }

        const switchTypeForm = document.querySelector(".switch-type-form");
        if (switchTypeForm) {
            switchTypeForm.addEventListener("submit", () => {
                let lat = searchLocationForm.getAttribute("data-selected-lat");
                let lng = searchLocationForm.getAttribute("data-selected-lng");

                if (lat !== "" && lng !== "") {
                    const latitudeInput = "<input name='Latitude' type='hidden' value='" + lat + "' />";
                    const longitudeInput = "<input name='Longitude' type='hidden' value='" + lng + "' />";
                    const postCodeInput = "<input name='Postcode' type='hidden' value='" + document.getElementById("Postcode").value + "'>";

                    switchTypeForm.innerHTML += latitudeInput;
                    switchTypeForm.innerHTML += longitudeInput;
                    switchTypeForm.innerHTML += postCodeInput;
                }
            });
        }
    });

    const filtering = {
        data: {
            currentFilter: "",
            currentPageSize: 9
        },
        filterItems: function (module, ctas, cta, btn) {
            const value = cta.value;
            const allItems = module.querySelectorAll(".filter-item");
            let itemsToFilter = allItems;
            let itemsForPage = [];

            this.data.currentPageSize = 9;

            Array.prototype.forEach.call(allItems, (item) => {
                item.classList.add("is-filtered");
                item.inert = true;
            });

            Array.prototype.forEach.call(ctas, (item) => {
                item.classList.add("is-contrast");
            });

            cta.blur();
            map.clearMarkers();

            if (value === this.data.currentFilter) {
                this.data.currentFilter = "";
                itemsForPage = Array.prototype.slice.call(itemsToFilter, 0, this.data.currentPageSize);

            } else {
                this.data.currentFilter = value;
                cta.classList.remove("is-contrast");

                itemsToFilter = module.querySelectorAll(`.filter-item[data-filter="${this.data.currentFilter}"]`);
                itemsForPage = Array.prototype.slice.call(itemsToFilter, 0, this.data.currentPageSize);
            }

            Array.prototype.forEach.call(itemsForPage, (item) => {
                item.classList.remove("is-filtered");
                item.inert = false;

                map.setMarker({
                    title: item.getAttribute("data-map-title"),
                    url: item.getAttribute("data-map-url"),
                    description: item.getAttribute("data-map-description"),
                    lat: parseFloat(item.getAttribute("data-map-lat")),
                    lng: parseFloat(item.getAttribute("data-map-lng"))
                });
            });

            if (itemsToFilter.length <= this.data.currentPageSize) {
                btn.classList.add("is-d-none");
            } else {
                btn.classList.remove("is-d-none");
            }
        },
        loadMore: function (module, btn) {
            const allItems = module.querySelectorAll(".filter-item");
            let itemsToFilter = this.data.currentFilter === "" ? allItems : module.querySelectorAll(`.filter-item[data-filter="${this.data.currentFilter}"]`);

            this.data.currentPageSize += 9;
            let loadMoreItems = Array.prototype.slice.call(itemsToFilter, 0, this.data.currentPageSize);
            
            Array.prototype.forEach.call(allItems, (item) => {
                item.classList.add("is-filtered");
                item.inert = true;
            });

            Array.prototype.forEach.call(loadMoreItems, (item) => {
                item.classList.remove("is-filtered");
                item.inert = false;

                map.setMarker({
                    title: item.getAttribute("data-map-title"),
                    url: item.getAttribute("data-map-url"),
                    description: item.getAttribute("data-map-description"),
                    lat: parseFloat(item.getAttribute("data-map-lat")),
                    lng: parseFloat(item.getAttribute("data-map-lng"))
                });
            });

            if (itemsToFilter.length <= this.data.currentPageSize) {
                btn.classList.add("is-d-none");
            } else {
                btn.classList.remove("is-d-none");
            }
        }
    };

    const map = {
        data: {
            map: null,
            allActiveMarkers: []
        },
        initMap: async function (el, centreLat, centreLng, zoom, locations) {
            const _this = this;

            // Do not continue if google maps is not loaded
            if (!window.google || !window.google.maps) {
                return;
            }

            // Request libraries when needed, not in the script tag.
            const { Map } = await google.maps.importLibrary("maps");
            // Short namespaces can be used.
            _this.data.map = new Map(el, {
                center: { lat: centreLat, lng: centreLng },
                zoom: zoom,
            });

            for (let loc of locations) {
                _this.setMarker(loc);
            }
        },
        setMarker: function (location) {
            const _this = this;
            const infoWindowContent = `
                <h3 class="is-h5 has-text-primary">
                    ${location.title}
                </h3>
                <p class="has-text-text has-mb-4">
                    ${location.description}
                </p>
                <a href="${location.url}" class="cta-text has-mb-3">
                    Learn more<span class="screen-reader-only"> about ${location.title}</span>
                </a>`;
            const infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });

            const marker = new google.maps.Marker({
                position: {lat: location.lat, lng: location.lng},
                map: _this.data.map
            });

            marker.addListener("click", () => {
                infoWindow.open(map, marker);
            });

            _this.data.allActiveMarkers.push(marker);
        },
        clearMarkers: function () {
            this.data.allActiveMarkers.forEach((marker) => {
                marker.setMap(null);
            });
        }
    }
})();